import {Button, copyToClipboard, IconButton} from 'platform/components';
import {Box, HStack, Show, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface OAuthClientSecretCardProps extends RequiredTestIdProps {
  clientSecret: string;
  canRegenerate: boolean;
  onRegenerate: () => void;
}

export function OAuthClientSecretCard(props: OAuthClientSecretCardProps) {
  return (
    <VStack spacing={1}>
      <Text size="small" color="tertiary">
        {i18n.t('general.labels.clientSecret')}
      </Text>
      <Box backgroundColor="palettes.neutral.20.100" borderRadius="small" padding={3}>
        <HStack spacing={2} align="center" justify="space-between">
          <Text size="small" data-testid={suffixTestId('value', props)}>
            {props.clientSecret}
          </Text>
          <HStack spacing={2} align="center">
            <IconButton
              icon="content/copy"
              priority="secondary"
              size="small"
              onClick={() => copyToClipboard(props.clientSecret)}
              aria-label={i18n.t('general.actions.copyToClipboard')}
              data-testid={suffixTestId('copy', props)}
            />
            <Show when={props.canRegenerate}>
              <Button
                variant="dangerLink"
                size="small"
                onClick={props.onRegenerate}
                title={i18n.t('entity.oauthClient.actions.regenerateSecret')}
                data-testid={suffixTestId('regenerate', props)}
              />
            </Show>
          </HStack>
        </HStack>
      </Box>
    </VStack>
  );
}
